export default __webpack_public_path__ + "static/media/dai_w.bd40d94c.svg";